export default {
  componentInstances: {}
}
